import { fetchPaymentSystems as fetchPaymentSystemsApi } from '@/entities/insurance/api';
import { Env } from '@/shared/config/environment';

const state = {
  paymentSystems: [],
  isLoading: false,
};

const mutations = {
  SET_PAYMENT_SYSTEMS(state, paymentSystems) {
    state.paymentSystems = paymentSystems;
  },
  SET_LOADING(state, isLoading) {
    state.isLoading = isLoading;
  },
  CLEAR_PAYMENT_SYSTEMS(state) {
    state.paymentSystems = [];
  },
};

const actions = {
  async fetchPaymentSystemsList({ commit, dispatch }, { companyId, programName }) {
    if (!companyId) return;

    commit('SET_LOADING', true);
    try {
      const response = await fetchPaymentSystemsApi(companyId, programName);
      commit('SET_PAYMENT_SYSTEMS', response ?? []);
    } catch (error) {
      const errorMessage = error.response?.data?.message
        || error.response?.data?.error
        || error.message
        || 'Не вдалося завантажити платіжні системи';

      if (Env.features.showNetworkErrorMessages) {
        dispatch('notificationModule/showNotificationErrorMessage', {
          error,
          title: 'Не вдалося завантажити платіжні системи',
          message: errorMessage,
        }, { root: true });
      }
    } finally {
      commit('SET_LOADING', false);
    }
  },
  clearPaymentSystems({ commit }) {
    commit('CLEAR_PAYMENT_SYSTEMS');
  },
};

const getters = {
  getPaymentSystems: state => state.paymentSystems,
  isPaymentSystemsLoading: state => state.isLoading,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};